export const MSG_ALREADY_AUTHENTICATED = 'You are already signed in.'
export const MSG_CHANGE_PASSWORD = 'Your password has been changed successfully.'
export const MSG_RESET_PASSWORD = email => `An email to ${email} has been sent with instructions how to reset the password`
export const MSG_RESET_ADMIN_PASSWORD = 'You will receive an email with instructions on how to reset your password in a few minutes.'
export const MSG_TRANSLATOR_SEND = 'Are you sure you want to send this message?'
export const MSG_NO_PLAYS = 'No plays...'
